<template>
  <button class="button" v-bind:disabled="disabled" @click="onClick">
    {{ label }}
  </button>
</template>

<script>
export default {
  name: "CtaButton",
  props: {
    onClick: Function,
    label: String,
    disabled: Boolean
  }
};
</script>

<style scoped>
.button {
  width: 100%;
  height: 40px;
  border: none;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 20px;
  background-color: #0821ff;
  transition: background-color 0.5s;
  outline: none;
}
.button:not(:disabled):hover {
  background-color: #085cff;
  cursor: pointer;
}
.button:disabled {
  background-color: #C4C9CB;
}
</style>
